import React from "react";
import Header from "../../../../../Components/Header";
import Salesform from "./Salesform";
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";


const EditSalesOrder = () => {
  const location = useLocation();
  const salesorderId = location.state?.salesorder;
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				  <title>Sales Order - Edit</title>
			  </Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column " style={{flexGrow:'1'}}>
        <Salesform salesorderId={salesorderId}/>
      </div>
      </div>
  );
};

export default EditSalesOrder;
